import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';

export default class Chat {
  constructor(chat) {
    this.id = chat.id;
    this.created_at = chat.created_at;
    this.updated_at = chat.updated_at;
    this.invite_link = chat.invite_link;
    this.options = chat.options || {};
    this.target_class = chat.target_class;
    this.target_id = chat.target_id;
    this.telegram_client_id = chat.telegram_client_id;
    this.telegram_id = chat.telegram_id;
    this.telegram_title = chat.telegram_title;
    this.telegram_username = chat.telegram_username;
  }

  remove() {
    return rHandler(
      apiService.delete(`/telegram?channel=${this.telegram_id}`),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  }
}
